import clsx from 'clsx';
import React from 'react';

import { useAppContext } from '../../contexts/AppContext';
import useServerSideRendering from '../../hooks/useServerSideRendering';
import { getImgxSrc } from '../../utils/images';
import Button from '../BaseUI/Button';
import { EventProp } from './TimeLine';

const VerticalTimePoint = ({ events }: { events: EventProp[] }) => {
  const hydrated = useServerSideRendering();
  const { env } = useAppContext();
  const firstEvent = events[0];
  const secondEvent = events[1];

  return (
    <>
      {hydrated && (
        <>
          <div className="tw-flex">
            <VerticalTimePointEvent eventType="ti">
              {firstEvent.month} <span className="tw-block sm:tw-inline">{firstEvent.year}</span>
            </VerticalTimePointEvent>
            <img
              className="tw-rotate-90 tw-absolute -tw-top-20 tw-left-48"
              src={getImgxSrc({
                path: 'brand_campaign/pinRed.svg',
                isDevDependence: true,
                envContext: env,
              })}
              alt="TI Event"
            />
            <div className="tw-absolute sm:tw-top-[2rem] sm:tw-left-112 sm:tw-ml-24 tw-top-56 tw-left-12">
              <img
                className="tw-max-w-[180px]"
                src={getImgxSrc({
                  path: firstEvent.logoPath,
                  isDevDependence: true,
                  envContext: env,
                })}
                alt="TI Logo"
              />
              <div className="tw-w-full tw-max-w-[260px] sm:tw-max-w-[350px]">
                <Button
                  variant="link"
                  className="tw-font-serif tw-text-button-lg sm:tw-text-[22px] sm:tw-leading-8 tw-underline tw-leading-6 tw-text-left tw-tracking-normal"
                  href={firstEvent.articleLink}
                >
                  “{firstEvent.articleTitle}”
                </Button>
              </div>
            </div>
          </div>
          <div className="tw-flex">
            <VerticalTimePointEvent eventType="competitor">
              {secondEvent.month} <span className="tw-block sm:tw-inline">{secondEvent.year}</span>
            </VerticalTimePointEvent>
            <img
              className="tw-rotate-90 tw-absolute tw-bottom-40 sm:tw-bottom-8 tw-left-48"
              src={getImgxSrc({
                path: 'brand_campaign/pinGray.svg',
                isDevDependence: true,
                envContext: env,
              })}
              alt="None TI Event"
            />
          </div>
          <div className="tw-absolute sm:tw-top-[222px] sm:tw-left-112 sm:tw-ml-24 -tw-bottom-8 sm:-tw-bottom-8 tw-left-12 tw-h-[108px] sm:tw-h-96">
            <img
              className="tw-max-w-[150px]"
              src={getImgxSrc({
                path: secondEvent.logoPath,
                isDevDependence: true,
                envContext: env,
              })}
              alt="Competitor Logo"
            />
            <div className="tw-w-full tw-max-w-[260px] sm:tw-max-w-[350px] tw-text-body-sm sm:tw-text-button-lg tw-font-serif tw-leading-6 sm:tw-leading-6 sm:tw-tracking-normal">
              “{secondEvent.articleTitle}”
            </div>
          </div>
        </>
      )}
    </>
  );
};

interface VerticalTimePointEventProps {
  eventType: 'ti' | 'competitor';
  children: React.ReactNode;
}

const VerticalTimePointEvent = ({ eventType, children }: VerticalTimePointEventProps) => {
  return (
    <div
      className={clsx(
        'tw-absolute sm:-tw-left-[9rem] sm:tw-text-button-md sm:tw-max-w-full tw-text-right -tw-left-56 tw-font-bold tw-text-[8px] tw-uppercase tw-w-40 sm:tw-w-[128px]',
        {
          'sm:tw-top-[2.7rem] tw-top-36 tw-text-pro-red': eventType === 'ti',
          'sm:tw-bottom-[4.25rem] tw-bottom-96': eventType === 'competitor',
        }
      )}
    >
      {children}
    </div>
  );
};

export default VerticalTimePoint;
